<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="公告类型：" prop="noticeType">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.noticeType"
                >
                  <template v-for="(value, key) in dictData['notice_type']">
                     <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="公告状态：" prop="noticeStatus">
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.noticeStatus"
                >
                  <template
                    v-for="(value, key) in dictData['sys_notice_status']"
                  >
                     <el-option
                      :key="value.value"
                      :label="value.label"
                      :value="value.value"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="操作人员：" prop="updateBy">
                <el-input
                  size="small"
                  v-model="queryParams.updateBy"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="公告标题：" prop="noticeTitle">
                <el-input
                  size="small"
                  v-model="queryParams.noticeTitle"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="添加时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="table-body">
      <div style="overflow: hidden;">
        <div class="left">
          <el-button
            type="primary"
            size="small"
            @click="handleShowEditNotice({})"
            >新增</el-button
          >
        </div>
        <pagination
          class="bottom-sticky"
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>

      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="公告标题" prop="noticeTitle">
          <template slot-scope="scope">
            <el-badge v-if="scope.row.isTop == '1'" value="置顶" class="item">
              <el-button type="text" @click="handleShowDetail(scope.row)"
                >{{ scope.row.noticeTitle }}
              </el-button>
            </el-badge>
            <el-button v-else type="text" @click="handleShowDetail(scope.row)"
              >{{ scope.row.noticeTitle }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="公告类型" prop="noticeType">
          <template slot-scope="scope">
            <span>{{ dictMap["notice_type"][scope.row.noticeType] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="公告状态" prop="noticeStatus">
          <template slot-scope="scope">
            <span>{{
              dictMap["sys_notice_status"][scope.row.noticeStatus]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作人员" prop="updateBy"></el-table-column>
        <el-table-column label="发布时间" prop="createTime"></el-table-column>
        <el-table-column label="操作" prop="oper" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              @click="handleShowEditNotice(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="mini"
              @click="handleDeleteNotice(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog :close-on-click-modal="false"  
      :title="editDialog.title"
      :visible.sync="editDialog.dialogVisible"
      width="1100px"
    >
      <el-form
        :model="editDialog.noticeForm"
        :rules="editDialog.rules"
        ref="noticeForm"
        label-width="140px"
      >
        <el-form-item label="公告类型" prop="amazonSite">
          <el-select
            clearable
            v-model="editDialog.noticeForm.noticeType"
            placeholder="请选择公告类型"
          >
            <template v-for="(value, key) in dictData['notice_type']">
              <el-option :key="key" :label="value.label" :value="value.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="公告标题" prop="noticeTitle">
          <el-input v-model="editDialog.noticeForm.noticeTitle"></el-input>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <CKEditor4
            v-model="editDialog.noticeForm.content"
            @getCkEditorInstance="getEditor"
            :config="editorConfig"
            @open="openUploadDialog"
          ></CKEditor4>
        </el-form-item>
        <el-form-item label="公告状态" prop="noticeStatus">
          <el-radio-group v-model="editDialog.noticeForm.noticeStatus">
            <template v-for="(value, key) in dictData['sys_notice_status']">
              <el-radio :label="value.value" :key="value.value"> {{ value.label }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否置顶" prop="isTop">
          <el-radio-group v-model="editDialog.noticeForm.isTop">
            <template v-for="(value, key) in dictData['yes_or_no']">
              <el-radio :label="key" :key="key"> {{ value }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editDialog.dialogVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleSaveNotice"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <LocalUpload :ckData="localUploadData"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData"></OnlineUpload>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  getNoticeList,
  exportNoticeList,
  addNotice,
  updateNotice,
  deleteNotice,
} from "@/api/sysSupport/notice"
import CKEditor4 from "@/components/common/CKEditor"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
    CKEditor4,
    LocalUpload,
    OnlineUpload,
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        noticeStatus: undefined,
        updateBy: undefined,
        noticeTitle: undefined,
        noticeType: undefined,
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      loading: false,
      total: 0,
      tableData: [],
      editDialog: {
        title: "",
        dialogVisible: false,
        noticeForm: {
          noticeStatus: "0",
        },
        rules: {
          noticeType: [
            { required: true, message: "请选择公告类型", trigger: "blur" },
          ],
          noticeTitle: [
            { required: true, message: "请输入公告标题", trigger: "blur" },
          ],
          // content: [
          //   { required: true, message: '请输入公告内容', trigger: 'blur' },
          // ],
          noticeStatus: [
            { required: true, message: "请选择公告状态", trigger: "blur" },
          ],
          isTop: [
            { required: true, message: "请选择是否置顶", trigger: "blur" },
          ],
        },
      },
      editor: null,
      editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],
        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
      },
      localUploadData: {
        visible: false,
        editor: null,
      },
      onlineUploadData: {
        visible: false,
        editor: null,
      },
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  created() {
    this.loadData()
  },
  methods: {
    /** 查询公告列表 */
    loadData() {
      this.loading = true
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      getNoticeList(params).then((response) => {
        this.tableData = response.rows
        this.total = response.total
        this.loading = false
      })
    },

    resetForm() {
      this.$refs["form"].resetFields()
    },

    /**显示编辑页面 */
    handleShowEditNotice(row) {
      if (row.noticeId) {
        this.editDialog.noticeForm = Object.assign({}, row)
        this.editDialog.title = "编辑公告"
      } else {
        this.editDialog.noticeForm = { isTop: "0", noticeStatus: "0" }
        this.editDialog.title = "新增公告"
      }
      this.editDialog.dialogVisible = true
      // this.editor.setData(row.content)
    },

    /**保存公告信息 */
    handleSaveNotice() {
      this.$refs["noticeForm"].validate((valid) => {
        if (valid) {
          this.editDialog.noticeForm.content = this.editor.getData()
          if (this.editDialog.noticeForm.noticeId) {
            updateNotice(this.editDialog.noticeForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("修改成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("修改失败")
              }
            })
          } else {
            addNotice(this.editDialog.noticeForm).then((response) => {
              if (response.code == "200") {
                this.$message.success("新增成功！")
                this.editDialog.dialogVisible = false
                this.loadData()
              } else {
                this.$message.error("新增失败")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    /**删除公告 */
    handleDeleteNotice(row) {
      this.$confirm("确认删除公告？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteNotice(row).then((response) => {
          if (response.code == "200") {
            this.$message.success("删除成功！")
            this.loadData()
          } else {
            this.$message.error("删除失败！")
          }
        })
      })
    },
    /**详情 */
    handleShowDetail(row) {
      this.$router.push({
        path: "/support/manage/notice/detail",
        query: { noticeId: row.noticeId },
      })
    },

    download(row) {
       if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]
      exportNoticeList(params).then((response) => {
        if (response.code == "200") {
          this.$message.success("导出成功！")
        } else {
          this.$message.error("导出失败！")
        }
      })
    },

    getEditor(editor) {
      this.editor = this.localUploadData.editor = this.onlineUploadData.editor = editor
    },
    openUploadDialog(val) {
      if (val == "local") {
        this.localUploadData.visible = true
      } else if (val == "online") {
        this.onlineUploadData.visible = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
::v-deep .el-badge__content {
  position: relative;
  top: 6px;
  right: 30px;
}
</style>
